import SlideLast from './SlideLast'

export default SlideLast
// eslint-disable-next-line import/export
export * from './SlideLast'
